import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.section`
  padding: 10px 0;
  color: #000;
  background-color: #eee;
  font-size: 11px;
  font-weight: 500;
  text-align: center;

  a {
    color: #000;
    font-weight: 700;
  }
`;

const Footer = () => (
  <FooterWrapper>
    Developed by&nbsp;
    <a
      href="/#"
      target="_blank"
      rel="noreferrer noopener"
    >
      <img src="https://www.carlsetzer.com/wp-content/uploads/2018/04/just-a-design-geek-icon.png" height="15" width="15"/>&nbsp;&nbsp;satzCalvin
    </a><div align="right">
    <iframe src="https://maculacalvin.netlify.com/" width="350" height="333" scrolling="no" frameborder="0"  overflow="hidden" ></iframe>; 
    </div>
  </FooterWrapper>
 
);

export default Footer;
